<div class="title mb-4" *ngIf="type == 'worker_invoice_request'">
    Anticipo de <app-deleted-label [resource]="transaction?.thirdParty"></app-deleted-label>: {{transaction?.total | currency: 'EUR':'symbol':'1.2-2' }}
</div>
<div class="grid mb-4" *ngIf="type != 'worker_invoice_request'">
    <div class="col-3 input-field">
        <label for="workerId">Operario</label>
        <p-dropdown [options]="workers" [(ngModel)]="filters.workerId" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona un operador" showClear
            ></p-dropdown>
    </div>
    <div class="col-3 input-field">
        <label for="workerId">Sociedad</label>
        <p-dropdown [options]="business" [(ngModel)]="filters.businessId" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona una sociedad" showClear
            ></p-dropdown>
    </div>
    <div class="col-2 input-field">
        <label for="dateStart">Desde</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateFrom" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"
            ></p-calendar>
    </div>
    <div class="col-2 input-field">
        <label for="dateEnd">Hasta</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateTo" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"
            ></p-calendar>
    </div>
    <div class="col flex gap-2" style="align-items: center;">
        <p-button label="Calcular" (click)="search()" class="mt-3" />
        <p-button label="Limpiar filtros" (click)="clearFilters()" class="mt-3" />
    </div>
</div>
<p-accordion [multiple]="true" [activeIndex]="allOpenIndexes">
    <p-accordionTab *ngFor="let workerBusiness of workerBusinesses; let i = index">
        <ng-template pTemplate="header">
            <div class="grid align-items-center" style="width: 100%;">
                <div class="col-1">
                    <p-checkbox [binary]="true"
                        [(ngModel)]="selectedWorkers[workerBusiness.workerId + '|' + workerBusiness.businessId]"
                        (onChange)="toggleAllCases(workerBusiness.workerId, workerBusiness.businessId, $event.checked)"
                        (click)="$event.stopPropagation()">
                    </p-checkbox>
                </div>
                <div class="col-2">
                    <span>{{workerBusiness.workerName}}</span>
                </div>
                <div class="col-3">
                    <span>Negocio: {{workerBusiness.businessName}}</span>
                </div>
                <div class="col-2">
                    <span>Subtotal: {{ workerBusiness.subtotal | currency: 'EUR' }}</span>
                </div>
                <div class="col-2">
                    <span>Impuestos: {{ workerBusiness.taxAmount | currency: 'EUR' }}</span>
                </div>
                <div class="col-2">
                    <span [ngClass]="{'text-danger': workerBusiness.total < 0}">Total: {{ workerBusiness.total | currency: 'EUR' }}</span>
                </div>
            </div>
        </ng-template>
        <div *ngIf="workerBusiness.cases.length > 0" class="mb-4">
            <span class="font-bold">Trabajos</span>
            <p-table #grid [value]="workerBusiness.cases"
                [(selection)]="selectedCases[workerBusiness.workerId + '|' + workerBusiness.businessId]"
                (selectionChange)="updateWorkerBusinessTotals(workerBusiness.workerId, workerBusiness.businessId)">            
                <ng-template pTemplate="header">
                    <tr>
                        <th pSelectableColumn></th>
                        <th pSortableColumn="caseNumber">Id Expediente <p-sortIcon field="caseNumber"></p-sortIcon></th>
                        <th pSortableColumn="caseType">Tipo <p-sortIcon field="caseType"></p-sortIcon></th>
                        <th pSortableColumn="date">Fecha visita <p-sortIcon field="date"></p-sortIcon></th>
                        <th pSortableColumn="reference">Fecha trabajo <p-sortIcon field="jobDate"></p-sortIcon></th>
                        <th pSortableColumn="client.name">Asegurado <p-sortIcon field="client.name"></p-sortIcon></th>
                        <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-case>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="case"></p-tableCheckbox>
                        </td>
                        <td>{{ case.caseNumber }}</td>
                        <td>{{ case.type }}</td>
                        <td>{{ case.date | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ case.jobDate | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ case.clientName }}</td>
                        <td>{{ case.total | currency:'EUR':'symbol':'1.2-2' }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div *ngIf="workerBusiness.billableItems.length > 0" class="mb-4">
            <span class="font-bold">Conceptos facturables</span>
            <p-table #grid [value]="workerBusiness.billableItems"
                [(selection)]="selectedBillableItems[workerBusiness.workerId + '|' + workerBusiness.businessId]"
                (selectionChange)="updateWorkerBusinessTotals(workerBusiness.workerId, workerBusiness.businessId)">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSelectableColumn></th>
                        <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon></th>                        
                        <th style="text-align: right;">Cantidad</th>
                        <th style="text-align: right;">Precio</th>
                        <th style="text-align: right;">Impuestos</th>
                        <th style="text-align: right;">Total</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-billableItem let-columns="columns">
                    <tr>
                        <td>
                            <p-tableCheckbox 
                                [value]="billableItem"></p-tableCheckbox>
                        </td>
                        <td>{{billableItem.description}}</td>
                        <td style="text-align: right;">
                            {{billableItem.quantity}}
                        </td>
                        <td style="text-align: right;">
                            {{billableItem.price | currency: 'EUR'}}
                        </td>
                        <td style="text-align: right;">                            
                            {{'('+billableItem.taxName+')'}} {{billableItem.taxAmount | currency: 'EUR' }}
                        </td>
                        <td style="text-align: right;">
                            {{getTotalBillableItem(billableItem) | currency: 'EUR' }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        
        <div *ngIf="workerBusiness.chargedByWorker.length > 0">
            <span class="font-bold">Anticipos</span>
            <p-table #grid [value]="workerBusiness.chargedByWorker"
                [(selection)]="selectedChargedByWorker[workerBusiness.workerId + '|' + workerBusiness.businessId]"
                (selectionChange)="updateWorkerBusinessTotals(workerBusiness.workerId, workerBusiness.businessId)">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSelectableColumn></th>
                        <th pSelectableColumn>Expediente</th>
                        <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                        <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon></th>                        
                        <th style="text-align: right;">Cantidad</th>
                        <th style="text-align: right;">Precio</th>
                        <th style="text-align: right;">Impuestos</th>
                        <th style="text-align: right;">Total</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-chargedByWorker let-columns="columns">
                    <tr>
                        <td>
                            <p-tableCheckbox 
                                [value]="chargedByWorker"></p-tableCheckbox>
                        </td>
                        <td>{{ chargedByWorker.caseNumber }}</td>
                        <td>{{chargedByWorker.date | date: 'dd/MM/yyyy'}}</td>
                        <td>{{chargedByWorker.description}}</td>
                        <td style="text-align: right;">
                            {{chargedByWorker.quantity}}
                        </td>
                        <td style="text-align: right;">
                            {{chargedByWorker.price | currency: 'EUR'}}
                        </td>
                        <td style="text-align: right;">                            
                            {{'('+chargedByWorker.taxName+')'}} {{chargedByWorker.taxAmount | currency: 'EUR' }}
                        </td>
                        <td style="text-align: right;">
                            {{getTotalChargedByWorker(chargedByWorker) | currency: 'EUR' }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </p-accordionTab>
</p-accordion>
<p-messages severity="error" *ngIf="hasNegativeTotal()">
    <ng-template pTemplate>
        No se pueden generar facturas con valor negativo.
    </ng-template>
</p-messages>
<div class="mt-4 flex gap-2 justify-content-end">
    <div style="text-align: right;">
        <h3><b>Subtotal:</b> {{ getSubtotalSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h3>
        <h3><b>Impuestos:</b> {{ getAmountSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h3>
        <!--<h3><b>Impuestos:</b> {{ getTaxSelected() | currency: 'EUR' }}</h3>-->
        <h2><b>Total:</b> {{ getTotalSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h2>
    </div>
</div>
<div class="mt-4 flex gap-2 justify-content-end">
    <p-button label="Generar factura" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
        (click)="showModal()" [disabled]="hasNegativeTotal()"></p-button>
</div>
<span *ngIf="workerBusinesses.length == 0">
    No se han encontrado expedientes a facturar
</span>

<p-dialog header="Selecciona una fecha de factura" [(visible)]="displayModal" [modal]="true" [closable]="false"
    [style]="{width: '300px'}">
    <div class="input-field col-12">
        <label for="date">Fecha</label>
        <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="selectedDate" [showIcon]="true" [showButtonBar]="true"
            [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error
            appendTo="body"></p-calendar>
    </div>
    <div class="input-field col-12 flex gap-2 align-items-center">
        <p-checkbox *ngIf="type=='incoming_invoice'" [binary]="true" id="isAdvancePayment" [(ngModel)]="isAdvancePayment"></p-checkbox>
        <label  *ngIf="type=='incoming_invoice'" for="isAdvancePayment">Anticipo</label>
    </div>
    <div class="input-field col-12" *ngIf="type=='incoming_invoice' && isAdvancePayment">
        <label for="advancePaymentPercent">% anticipo</label>
        <p-inputNumber id="advancePaymentPercent" [(ngModel)]="advancePaymentPercent" suffix="%"
            [min]="0" [max]="100" [minFractionDigits]="0" [maxFractionDigits]="2"></p-inputNumber>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-space-between">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="hideModal()"></button>
            <button pButton label="Guardar" icon="pi pi-check" (click)="save()"></button>
        </div>
    </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>